/*
 * Сообщение в потоке страницы. Держится на тинте тона и hairline того же тона, поэтому
 * блок forced-colors обязателен: без него в высокой контрастности Windows от алерта
 * не остаётся ни фона, ни рамки.
 *
 * Своего РАЗМЫТИЯ у алерта нет намеренно: алерт без контейнера не встречается — он живёт
 * в форме, карточке, модалке или панели, и подложка под ним уже размыта. Размывать размытое —
 * слой композитинга за ноль видимого эффекта, а в форме проверок алертов бывает пять-шесть
 * подряд. А вот подложка под тинтом есть, и она общая с Banner и полосой AppTopBar:
 * --glass-tint-base. Тинт в 12-18 % ничего не изолирует, его итоговый цвет задаёт то, что
 * снизу, и на стекле поверх произвольного содержимого тон проваливал AA (2.95-3.74:1).
 * Подложка ставит тинт на известный слой, и цифры перестают зависеть от чужого материала.
 * Разбор — docs/ui-kit/contracts/alert.md, раздел «Материал».
 *
 * Цвет собирается в два шага, как у StatusBadge: класс тона объявляет палитру роли
 * (--alert-tint / -text / -border / -fill / -glyph), корень раскладывает её по узлам.
 * Справа от каждой локальной переменной стоит токен, не значение.
 *
 * Медиазапросов по ширине нет: плотность выбирается пропом size, а не экраном, — база
 * и есть мобильный вид. Переносы длинного артикула держит .text, а не контейнер.
 */

.root {
  --alert-pad-y: var(--space-3);
  --alert-pad-x: var(--space-35);
  --alert-gap: var(--space-3);
  --alert-radius: var(--radius-menu);

  /* Палитра роли по умолчанию — accent: условие, о котором надо знать заранее */
  --alert-tint: var(--color-accent-tint);
  --alert-text: var(--color-accent-text);
  --alert-border: var(--color-accent-border);
  --alert-fill: var(--gradient-accent);
  --alert-glyph: var(--color-accent-text-on-solid);

  display: flex;
  box-sizing: border-box;
  gap: var(--alert-gap);
  align-items: flex-start;
  width: 100%;
  padding: var(--alert-pad-y) var(--alert-pad-x);

  /* Тинт лежит НА подложке, а не вместо неё: пара «тон + --glass-tint-base» одна
     и та же у Alert, Banner и полосы состояния AppTopBar */
  background: linear-gradient(var(--alert-tint), var(--alert-tint)), var(--glass-tint-base);
  border: var(--border-hairline) solid var(--alert-border);
  border-radius: var(--alert-radius);
}

/* Ступени: кит рисует pad 12/14 r16 у алерта формы и 9/11 r14 у строки проверок */

.sm {
  --alert-pad-y: var(--space-25);
  --alert-pad-x: var(--space-3);
  --alert-gap: var(--space-25);
  --alert-radius: var(--radius-field);
}

.md {
  --alert-pad-y: var(--space-3);
  --alert-pad-x: var(--space-35);
  --alert-gap: var(--space-3);
  --alert-radius: var(--radius-menu);
}

/* Палитра тона */

.toneAccent {
  --alert-tint: var(--color-accent-tint);
  --alert-text: var(--color-accent-text);
  --alert-border: var(--color-accent-border);
  --alert-fill: var(--gradient-accent);
  --alert-glyph: var(--color-accent-text-on-solid);
}

.toneSuccess {
  --alert-tint: var(--color-success-tint);
  --alert-text: var(--color-success-text);
  --alert-border: var(--color-success-border);
  --alert-fill: var(--gradient-success);
  --alert-glyph: var(--color-success-text-on-solid);
}

.toneWarning {
  --alert-tint: var(--color-warning-tint);
  --alert-text: var(--color-warning-text);
  --alert-border: var(--color-warning-border);
  --alert-fill: var(--gradient-warning);
  --alert-glyph: var(--color-warning-text-on-solid);
}

/*
 * Красный на красной подложке всегда -strong: слитый по Q9 --color-danger-text даёт на ней
 * 4.01-4.56:1 в светлой теме — ниже AA. У -strong 5.72-6.50 в светлой и 6.76-8.19 в тёмной.
 */
.toneDanger {
  --alert-tint: var(--color-danger-tint);
  --alert-text: var(--color-danger-text-strong);
  --alert-border: var(--color-danger-border);
  --alert-fill: var(--gradient-danger);
  --alert-glyph: var(--color-danger-text-on-solid);
}

/*
 * Маркер прижат к первой строке, а не к центру блока: точка по центру трёхстрочного
 * сообщения читается как маркер списка. Отступ сверху центрирует её относительно строки
 * 12.5-13.5px с line-height 1.5.
 */
.dot {
  flex: 0 0 auto;
  width: var(--alert-dot);
  height: var(--alert-dot);
  margin-top: var(--space-15);
  background: var(--alert-fill);
  border-radius: var(--radius-circle);
}

/* Кружок с иконкой: заливка тона, глиф — цветом «на заливке», а не белым:
   в тёмной теме градиент светлеет и белый давал бы 1.9:1 (тот же расчёт, что у StatusBadge). */
.marker {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: var(--alert-marker);
  height: var(--alert-marker);
  color: var(--alert-glyph);
  background: var(--alert-fill);
  border-radius: var(--radius-circle);
}

/* min-width: 0 — иначе артикул на 40 символов распирает флекс-строку и рвёт вёрстку на 360px */
.content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.heading {
  color: var(--alert-text);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-text);
  letter-spacing: var(--tracking-control);
}

/*
 * break-word, а не anywhere: последний — Safari 15.4+, при планке проекта 14.1 он молча
 * откатывается к normal, и артикул пробивает контейнер. Перенос по символу нужен только
 * когда другого места нет: overflow-wrap, а не
 * word-break, иначе «1 284 500 000 ₽» разваливается посреди разряда.
 * Многоточия нет намеренно: алерт — абзац, ему можно расти.
 */
.text {
  overflow-wrap: break-word;
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-text);
}

/* Единственная строка сообщения несёт весь смысл: тон и вес переходят на неё */
.textLead {
  color: var(--alert-text);
  font-weight: var(--font-weight-semibold);
}

/* Место действия принадлежит алерту, содержимое слота — потребителю */
.action {
  margin-top: var(--space-1);
}

/*
 * Алерт держится на заливке и рамке: в высокой контрастности Windows обе сбрасываются.
 * Тон при этом теряется — это допустимо, смысл несёт текст.
 */
@media (forced-colors: active) {
  .root {
    background: Canvas;
    border-color: CanvasText;
  }

  .heading,
  .textLead {
    color: CanvasText;
  }

  .dot {
    background: CanvasText;
  }

  .marker {
    color: Canvas;
    background: CanvasText;
  }
}
